<button class="colab-module-card" [class]="{ overflow: isOverflow }" (click)="onSelectModule()">
  <div class="module-text">
    <div class="header-group">
      <h4 class="wtw-typography-display--xs wtw-typography-font-weight--bold">{{ title }}</h4>
      <span class="wtw-functional-icons wtw-icon-size--2xl" aria-hidden="true">arrow_outward</span>
    </div>
    <p class="wtw-typography-text--sm wtw-typography-font-weight--medium" [innerHTML]="text"></p>
  </div>
  @if (code && !imageLoadFailed) {
    <img class="wtw-card--image-full-bleed" [src]="'assets/images/' + code + '.png'" [alt]="title" (error)="onModuleImageError()" />
  }
</button>
